import { Component, OnInit } from '@angular/core';
import { Filter } from '@docpath/linces-angular-components/common';
import { Table } from '@docpath/webcomponents';
import { Subscription } from 'rxjs';

import { AliasTableService } from './components/table/alias-table.service';
import { Alias } from './models/alias';
import { AliasService } from './services/alias.service';

@Component({
  selector: 'app-configuration-alias',
  templateUrl: './alias.component.html'
})
export class AliasComponent implements OnInit {
  private table?: Table;
  private aliasChangedSubscription?: Subscription;
  selectedAlias: Alias[] = [];
  filters: Filter[] = [];
  
  
  constructor(
    private readonly aliasTableService: AliasTableService,
    private readonly aliasService: AliasService
  ) { 
    //
  }

  ngOnInit(): void {
    if (!this.aliasChangedSubscription) {
      this.aliasChangedSubscription = this.aliasService.aliasChanged.subscribe(() => this.refreshAlias());
    }
  }

  OnDestroy(): void {
    if (this.aliasChangedSubscription) {
      this.aliasChangedSubscription.unsubscribe();
    }
  }

  onCheckChange(): void {
    if (this.table) {
      this.selectedAlias = this.aliasTableService.getSelectedAlias(this.table);
    }
  }

  getTable(): Table | undefined {
    return this.table;
  }

  onTableLoaded(table: Table): void {
    this.table = table;
  }

  onFilterChange(filters: Filter[]): void {
    this.filters = filters;
  }

  private refreshAlias(): void {
    this.aliasTableService.loadAlias(this.filters, 1);
  }

  getSelectedAliasCount(): number {
    if (this.table) {
      const alias = this.aliasTableService.getSelectedAlias(this.table);
      return alias.length;
    }
    return 0;
  }

  getSelectedAlias(): Alias | undefined {
    if (this.table) {
      const indexServices = this.aliasTableService.getSelectedAlias(this.table);
      return indexServices.length === 1 ? indexServices[0] : undefined;
    }

    return undefined;
  }

}

